module.exports = "https://cdn.realtymogul.com/static/media/icon_tenants.a1380d03.svg";